(function(){
  "use strict";

  var STORAGE_KEY = "tf_address";
  var STORAGE_STATE_KEY = "tf_state";
  var URL_PARAM = "address";
  var MAPS_API_KEY = "AIzaSyC_O-x6rJdOOTigz62uTZjWUzcCPgfQW44";
  var DISALLOWED_STATE_CODE = "NSW";
  var NSW_UNAVAILABLE_MESSAGE = "Sorry, we no longer sell NSW title searches. Please choose a non-NSW property.";
  var NSW_VARIANT_IDS = [
    47874873032963,
    47874873065731,
    47874873098499,
    47874873131267,
    47875774185731
  ];

  // Australia-wide bounds
  var AU_BOUNDS = { south: -44, west: 112, north: -10, east: 154 };

  // State → page mapping
  var STATE_PAGES = {
    "QLD": "/collections/titles",
    "VIC": "/pages/victoria",
    "SA": "/pages/south-australia",
    "WA": "/pages/western-australia",
    "TAS": "/pages/tasmania",
    "ACT": "/pages/act",
    "NT": "/pages/northern-territory"
  };

  function getAddress() {
    return localStorage.getItem(STORAGE_KEY) || "";
  }

  function isNSWPostcode(postcode) {
    var code = parseInt(postcode, 10);
    return (code >= 1000 && code <= 1999) ||
      (code >= 2000 && code <= 2599) ||
      (code >= 2619 && code <= 2899) ||
      (code >= 2921 && code <= 2999);
  }

  function addressLooksLikeNSW(addr) {
    var text = String(addr || "").toUpperCase();
    if (!text) return false;
    if (/\bNSW\b/.test(text) || /\bNEW SOUTH WALES\b/.test(text)) return true;
    var postcodeMatch = text.match(/\b(\d{4})\b(?:\s*,?\s*AUSTRALIA)?$/);
    return postcodeMatch ? isNSWPostcode(postcodeMatch[1]) : false;
  }

  function placeStateCode(place) {
    var stateCode = null;
    (place && place.address_components || []).forEach(function(c) {
      if (c.types.indexOf("administrative_area_level_1") !== -1) {
        stateCode = c.short_name;
      }
    });
    return stateCode;
  }

  function isNSWAddress(addr, stateCode) {
    return stateCode === DISALLOWED_STATE_CODE || addressLooksLikeNSW(addr);
  }

  function clearSavedAddress() {
    localStorage.removeItem(STORAGE_KEY);
    localStorage.removeItem(STORAGE_STATE_KEY);
    localStorage.removeItem("selectedAddress");
  }

  function showNSWUnavailable(input) {
    clearSavedAddress();
    if (input) {
      input.value = "";
      input.classList.remove("valid-address");
      input.style.borderColor = "#ef4444";
      input.style.backgroundColor = "#fef2f2";
      input.focus();
    }
    var helpEl = document.getElementById("buy-now-help");
    if (helpEl) {
      helpEl.textContent = NSW_UNAVAILABLE_MESSAGE;
      helpEl.style.display = "block";
    } else {
      alert(NSW_UNAVAILABLE_MESSAGE);
    }
  }

  function setAddress(addr, state) {
    if (!addr || !addr.trim()) return false;
    if (isNSWAddress(addr, state)) {
      showNSWUnavailable(getAddressInput());
      return false;
    }
    localStorage.setItem(STORAGE_KEY, addr.trim());
    if (state) localStorage.setItem(STORAGE_STATE_KEY, state);
    return true;
  }

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name) || "";
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str;
    return div.innerHTML;
  }

  function getAddressInput() {
    return document.getElementById("address-input") || document.getElementById("tf-hero-addr");
  }

  function isHomepageHeroInput(input) {
    return input && input.id === "tf-hero-addr" && (window.location.pathname === "/" || window.location.pathname === "");
  }

  function keepHomepageHeroBlank(input) {
    if (!isHomepageHeroInput(input)) return;
    input.value = "";
    input.classList.remove("valid-address");
    input.setAttribute("autocomplete", "new-password");
  }

  function ensureGooglePlaces() {
    if (window.google && window.google.maps && window.google.maps.places) return;
    if (document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]')) return;

    var script = document.createElement("script");
    script.src = "https://maps.googleapis.com/maps/api/js?key=" + MAPS_API_KEY + "&libraries=places";
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  // Restore address from URL param
  var urlAddr = getUrlParam(URL_PARAM);
  if (urlAddr) setAddress(urlAddr);

  // =========================================================
  // CUSTOM AUTOCOMPLETE — Australia-wide
  // =========================================================
  window.initTFAddressAutocomplete = function() {
    var input = getAddressInput();
    if (!input || input.__customAC) return;
    if (!window.google || !window.google.maps || !window.google.maps.places) return;
    keepHomepageHeroBlank(input);

    // Kill Google's default pac-containers
    document.querySelectorAll(".pac-container").forEach(function(el) { el.remove(); });
    var pacObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        m.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && node.classList && node.classList.contains("pac-container")) {
            node.remove();
          }
        });
      });
    });
    pacObserver.observe(document.body, { childList: true });

    var pacKillCSS = document.createElement("style");
    pacKillCSS.textContent = ".pac-container { display: none !important; visibility: hidden !important; }";
    document.head.appendChild(pacKillCSS);

    var service = new google.maps.places.AutocompleteService();
    var placesService = new google.maps.places.PlacesService(document.createElement("div"));
    var bounds = new google.maps.LatLngBounds(
      new google.maps.LatLng(AU_BOUNDS.south, AU_BOUNDS.west),
      new google.maps.LatLng(AU_BOUNDS.north, AU_BOUNDS.east)
    );

    // Create custom dropdown
    var dropdown = document.createElement("div");
    dropdown.id = "tf-custom-dropdown";

    var isMobile = window.innerWidth <= 768 || ("ontouchstart" in window);

    if (isMobile) {
      dropdown.style.cssText = [
        "display:none","position:fixed","z-index:99999","background:#fff",
        "border-radius:16px 16px 0 0","box-shadow:0 -4px 32px rgba(0,0,0,0.25)",
        "max-height:40vh","overflow-y:auto","bottom:0","left:0","right:0","width:100%",
        "font-family:Inter,system-ui,sans-serif","-webkit-overflow-scrolling:touch",
        "padding-bottom:env(safe-area-inset-bottom, 0px)"
      ].join(";");
      document.body.appendChild(dropdown);
    } else {
      var isHomepageHero = isHomepageHeroInput(input);
      dropdown.style.cssText = isHomepageHero ? [
        "display:none","position:static","z-index:99999","background:#fff",
        "border-radius:12px","box-shadow:0 8px 32px rgba(0,0,0,0.16)",
        "max-height:260px","overflow-y:auto","width:100%","margin-top:8px",
        "font-family:Inter,system-ui,sans-serif","-webkit-overflow-scrolling:touch"
      ].join(";") : [
        "display:none","position:absolute","z-index:99999","background:#fff",
        "border-radius:12px","box-shadow:0 8px 32px rgba(0,0,0,0.2)",
        "max-height:260px","overflow-y:auto","width:100%","left:0","right:0",
        "top:calc(100% + 8px)",
        "font-family:Inter,system-ui,sans-serif","-webkit-overflow-scrolling:touch"
      ].join(";");
      var wrapper = isHomepageHero ? input.closest('.tf-hero__search') : input.parentElement;
      if (wrapper) {
        wrapper.style.position = "relative";
        wrapper.appendChild(dropdown);
      }
    }

    var debounceTimer = null;
    var interactingWithDropdown = false;

    function showPredictions(predictions) {
      if (!predictions || !predictions.length) {
        dropdown.style.display = "none";
        return;
      }

      predictions = predictions.filter(function(prediction) {
        return !isNSWAddress(prediction.description) &&
          !isNSWAddress((prediction.structured_formatting || {}).secondary_text);
      });

      if (!predictions.length) {
        dropdown.style.display = "none";
        return;
      }

      dropdown.innerHTML = "";

      if (isMobile) {
        var header = document.createElement("div");
        header.style.cssText = "padding:12px 16px 8px;font-size:13px;color:#64748b;font-weight:600;border-bottom:1px solid #e2e8f0;display:flex;justify-content:space-between;align-items:center;";
        header.innerHTML = '<span>Australian Addresses</span><span style="cursor:pointer;font-size:18px;padding:4px 8px;" id="tf-dd-close">\u2715</span>';
        dropdown.appendChild(header);
        header.querySelector("#tf-dd-close").addEventListener("click", function(e) {
          e.preventDefault();
          dropdown.style.display = "none";
        });
        setTimeout(function() { input.scrollIntoView({ behavior: "smooth", block: "start" }); }, 100);
      }

      predictions.forEach(function(pred) {
        var item = document.createElement("div");
        item.className = "tf-ac-item";
        item.innerHTML = '<div style="display:flex;align-items:center;gap:10px;pointer-events:none;">' +
          '<svg style="width:18px;height:18px;flex-shrink:0;pointer-events:none;" viewBox="0 0 24 24" fill="none" stroke="#94a3b8" stroke-width="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/></svg>' +
          '<div style="pointer-events:none;">' +
            '<div style="font-size:15px;color:#0f172a;font-weight:500;">' + escapeHtml(pred.structured_formatting.main_text) + '</div>' +
            '<div style="font-size:13px;color:#64748b;">' + escapeHtml(pred.structured_formatting.secondary_text || "") + '</div>' +
          '</div></div>';

        item.style.cssText = [
          "padding:16px","cursor:pointer","border-bottom:1px solid #f1f5f9",
          "-webkit-tap-highlight-color:rgba(23,162,184,0.15)","touch-action:manipulation",
          "user-select:none","-webkit-user-select:none","min-height:52px"
        ].join(";");

        function doSelect(e) {
          if (e) { e.preventDefault(); e.stopPropagation(); }
          interactingWithDropdown = false;
          selectPrediction(pred);
        }

        item.addEventListener("mousedown", function(e) { e.preventDefault(); interactingWithDropdown = true; });
        item.addEventListener("touchstart", function(e) { e.preventDefault(); interactingWithDropdown = true; this.style.background = "#e0f2fe"; }, { passive: false });
        item.addEventListener("touchend", function(e) { e.preventDefault(); e.stopPropagation(); this.style.background = ""; doSelect(e); }, { passive: false });
        item.addEventListener("click", doSelect);
        item.addEventListener("mouseenter", function() { this.style.background = "#f0f8ff"; });
        item.addEventListener("mouseleave", function() { this.style.background = ""; });
        item.addEventListener("touchmove", function() { interactingWithDropdown = false; this.style.background = ""; }, { passive: true });

        dropdown.appendChild(item);
      });

      dropdown.style.display = "block";
    }

    function selectPrediction(prediction) {
      dropdown.style.display = "none";
      dropdown.innerHTML = "";
      input.value = prediction.description;

      placesService.getDetails(
        { placeId: prediction.place_id, fields: ["formatted_address", "address_components"] },
        function(place, status) {
          if (status !== "OK" || !place) {
            if (setAddress(prediction.description)) {
              navigateToState(prediction.description, null);
            }
            return;
          }

          // Detect state from address components
          var stateCode = placeStateCode(place);

          var addr = place.formatted_address || prediction.description;
          if (isNSWAddress(addr, stateCode)) {
            showNSWUnavailable(input);
            return;
          }
          setAddress(addr, stateCode);
          input.value = addr;
          input.classList.add("valid-address");
          navigateToState(addr, stateCode);
        }
      );
    }

    function navigateToState(address, stateCode) {
      if (isNSWAddress(address, stateCode)) {
        showNSWUnavailable(getAddressInput());
        return;
      }
      var page = stateCode && STATE_PAGES[stateCode] ? STATE_PAGES[stateCode] : "/collections/titles";
      window.location.href = page + "?address=" + encodeURIComponent(address);
    }

    // Input handler with debounce
    input.addEventListener("input", function() {
      var val = this.value.trim();
      input.classList.remove("valid-address");
      clearTimeout(debounceTimer);

      if (val.length < 3) {
        dropdown.style.display = "none";
        return;
      }

      debounceTimer = setTimeout(function() {
        service.getPlacePredictions(
          {
            input: val,
            bounds: bounds,
            componentRestrictions: { country: "AU" },
            types: ["address"]
          },
          function(predictions, status) {
            if (status === "OK") showPredictions(predictions);
            else dropdown.style.display = "none";
          }
        );
      }, 250);
    });

    input.addEventListener("blur", function() {
      if (!interactingWithDropdown) {
        setTimeout(function() { dropdown.style.display = "none"; }, 200);
      }
    });

    input.addEventListener("focus", function() {
      if (isHomepageHeroInput(this)) {
        dropdown.style.display = "none";
        return;
      }
      if (this.value.trim().length >= 3) {
        this.dispatchEvent(new Event("input"));
      }
    });

    // Restore saved address
    var saved = getAddress();
    if (isHomepageHeroInput(input)) {
      keepHomepageHeroBlank(input);
    } else if (saved) {
      if (isNSWAddress(saved, localStorage.getItem(STORAGE_STATE_KEY))) {
        clearSavedAddress();
      } else {
        input.value = saved;
        input.classList.add("valid-address");
      }
    }

    input.__customAC = true;
  };

  function isNSWProductPage() {
    return /^\/products\/nsw-/i.test(window.location.pathname);
  }

  function payloadContainsNSWVariant(payload) {
    if (!payload || typeof payload !== "object") return false;
    var id = payload.id || payload.variant_id;
    if (id && NSW_VARIANT_IDS.indexOf(parseInt(id, 10)) !== -1) return true;
    var items = Array.isArray(payload.items) ? payload.items : [];
    return items.some(function(item) {
      return item && NSW_VARIANT_IDS.indexOf(parseInt(item.id || item.variant_id, 10)) !== -1;
    });
  }

  function payloadContainsNSWAddress(payload) {
    if (!payload || typeof payload !== "object") return false;
    var props = payload.properties || {};
    if (isNSWAddress(props["Property Address"] || props.PropertyAddress || payload.address)) return true;
    var items = Array.isArray(payload.items) ? payload.items : [];
    return items.some(function(item) {
      var itemProps = item && item.properties || {};
      return isNSWAddress(itemProps["Property Address"] || itemProps.PropertyAddress || item.address);
    });
  }

  function lineItemIsBlocked(item) {
    if (!item) return false;
    var variantId = parseInt(item.variant_id || item.id, 10);
    if (NSW_VARIANT_IDS.indexOf(variantId) !== -1) return true;
    var props = item.properties || {};
    if (isNSWAddress(props["Property Address"] || props.PropertyAddress || item.address)) return true;
    return /\bNSW\b|New South Wales/i.test(String(item.title || item.product_title || item.handle || ""));
  }

  function cartHasBlockedNSWItems(cart) {
    var items = cart && Array.isArray(cart.items) ? cart.items : [];
    return items.some(lineItemIsBlocked);
  }

  function formDataContainsNSW(body) {
    if (!body || typeof body.forEach !== "function") return false;
    var blocked = false;
    body.forEach(function(value, key) {
      if (/^id$|variant/i.test(key) && NSW_VARIANT_IDS.indexOf(parseInt(value, 10)) !== -1) blocked = true;
      if (/address|Property Address/i.test(key) && isNSWAddress(value)) blocked = true;
    });
    return blocked;
  }

  function cartPayloadIsBlocked(body) {
    if (isNSWProductPage()) return true;
    if (!body) return false;
    try {
      if (typeof body === "string") {
        var parsed = JSON.parse(body);
        return payloadContainsNSWVariant(parsed) || payloadContainsNSWAddress(parsed);
      }
      if (typeof FormData !== "undefined" && body instanceof FormData) {
        return formDataContainsNSW(body);
      }
      if (typeof URLSearchParams !== "undefined" && body instanceof URLSearchParams) {
        return formDataContainsNSW(body);
      }
      return payloadContainsNSWVariant(body) || payloadContainsNSWAddress(body);
    } catch (e) {
      return addressLooksLikeNSW(String(body));
    }
  }

  function disableNSWProductPage() {
    if (!isNSWProductPage()) return;
    var btn = document.getElementById("buy-now-button");
    if (btn) {
      btn.disabled = true;
      btn.textContent = "NSW searches unavailable";
      btn.style.opacity = "0.65";
      btn.style.cursor = "not-allowed";
    }
    var helpEl = document.getElementById("buy-now-help");
    if (helpEl) {
      helpEl.textContent = NSW_UNAVAILABLE_MESSAGE;
      helpEl.style.display = "block";
    }
  }

  function interceptNSWCartAdds() {
    if (!window.fetch || window.fetch.__tfNSWGuard) return;
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
      var target = typeof url === "string" ? url : (url && url.url) || "";
      if (target.indexOf("/cart/add") !== -1 && cartPayloadIsBlocked(options && options.body)) {
        showNSWUnavailable(document.getElementById("product-address-input") || getAddressInput());
        return Promise.reject(new Error(NSW_UNAVAILABLE_MESSAGE));
      }
      return originalFetch.apply(this, arguments);
    };
    window.fetch.__tfNSWGuard = true;
  }

  var checkoutBlockedByNSW = false;

  function checkoutTargets() {
    return Array.prototype.slice.call(document.querySelectorAll([
      'a[href*="/checkout"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      'button[type="submit"][formaction*="/checkout"]',
      'input[type="submit"][formaction*="/checkout"]'
    ].join(",")));
  }

  function showCartNSWBlocked() {
    var message = NSW_UNAVAILABLE_MESSAGE;
    var container = document.querySelector("form[action*='/cart']") || document.querySelector("main") || document.body;
    var notice = document.getElementById("tf-nsw-cart-block");
    if (!notice && container) {
      notice = document.createElement("div");
      notice.id = "tf-nsw-cart-block";
      notice.setAttribute("role", "alert");
      notice.style.cssText = [
        "margin:16px 0","padding:14px 16px","border:1px solid #fecaca",
        "border-radius:10px","background:#fef2f2","color:#991b1b",
        "font-weight:600","line-height:1.45"
      ].join(";");
      container.insertBefore(notice, container.firstChild);
    }
    if (notice) notice.textContent = message;
    checkoutTargets().forEach(function(el) {
      el.setAttribute("aria-disabled", "true");
      el.disabled = true;
      el.style.opacity = "0.55";
      el.style.pointerEvents = "none";
      el.style.cursor = "not-allowed";
    });
  }

  function checkCartForNSW() {
    if (!window.fetch) return Promise.resolve(false);
    return window.fetch("/cart.js", { credentials: "same-origin" })
      .then(function(res) { return res.ok ? res.json() : null; })
      .then(function(cart) {
        checkoutBlockedByNSW = cartHasBlockedNSWItems(cart);
        if (checkoutBlockedByNSW) showCartNSWBlocked();
        return checkoutBlockedByNSW;
      })
      .catch(function() { return checkoutBlockedByNSW; });
  }

  function continueCheckout(target) {
    var link = target && target.closest && target.closest('a[href*="/checkout"]');
    if (link && link.href) {
      window.location.href = link.href;
      return;
    }
    var form = target && target.closest && target.closest("form");
    if (form && typeof form.submit === "function") form.submit();
  }

  function guardCheckoutEvent(event) {
    var target = event.target && event.target.closest && event.target.closest([
      'a[href*="/checkout"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      'button[type="submit"][formaction*="/checkout"]',
      'input[type="submit"][formaction*="/checkout"]'
    ].join(","));
    if (!target && event.type !== "submit") return;
    event.preventDefault();
    event.stopPropagation();
    checkCartForNSW().then(function(blocked) {
      if (blocked) {
        showCartNSWBlocked();
      } else if (target) {
        continueCheckout(target);
      } else if (event.target && typeof event.target.submit === "function") {
        event.target.submit();
      }
    });
  }

  function installCartCheckoutGuard() {
    checkCartForNSW();
    document.addEventListener("click", guardCheckoutEvent, true);
    document.addEventListener("submit", function(event) {
      var form = event.target;
      if (form && /\/cart|\/checkout/i.test(form.getAttribute("action") || "")) {
        guardCheckoutEvent(event);
      }
    }, true);
  }

  window.__tfAddressGuard = {
    isNSWAddress: isNSWAddress,
    isNSWProductPage: isNSWProductPage,
    cartPayloadIsBlocked: cartPayloadIsBlocked,
    cartHasBlockedNSWItems: cartHasBlockedNSWItems,
    checkCartForNSW: checkCartForNSW,
    nswVariantIds: NSW_VARIANT_IDS.slice()
  };

  interceptNSWCartAdds();
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", disableNSWProductPage);
    document.addEventListener("DOMContentLoaded", installCartCheckoutGuard);
  } else {
    disableNSWProductPage();
    installCartCheckoutGuard();
  }

  // Poll until Google Maps API is ready
  ensureGooglePlaces();

  var pollCount = 0;
  var pollTimer = setInterval(function() {
    pollCount++;
    if (window.google && window.google.maps && window.google.maps.places && typeof window.initTFAddressAutocomplete === "function") {
      clearInterval(pollTimer);
      window.initTFAddressAutocomplete();
    }
    if (pollCount > 100) clearInterval(pollTimer);
  }, 100);

  function clearHomepageHeroAfterBrowserRestore() {
    var input = document.getElementById("tf-hero-addr");
    keepHomepageHeroBlank(input);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", clearHomepageHeroAfterBrowserRestore);
  } else {
    clearHomepageHeroAfterBrowserRestore();
  }
  window.addEventListener("pageshow", clearHomepageHeroAfterBrowserRestore);
  window.addEventListener("load", clearHomepageHeroAfterBrowserRestore);

})();
